import { inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/abstract-classes/api.service/api.service';
import { GemstoneArrangement } from 'src/app/interfaces/gemstone-arrangement';
import { StoneArrangementsProviderService } from 'src/app/providers/stone-arrangements/stone-arrangements.provider.service';

@Injectable({
  providedIn: 'root'
})
export class StoneArrangementsService extends ApiService<GemstoneArrangement, StoneArrangementsProviderService> {
  private providerService = inject(StoneArrangementsProviderService);
  protected override get provider(): StoneArrangementsProviderService {
    return this.providerService;
  }
}
